export default "__VITE_ASSET__154efe5d__"